var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "editt_2",
    "data-name": "editt 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1504",
    "data-name": "Rectangle 1504",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphic-design_2_",
    transform: "translate(-0.976 1.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M32.451,3.522a.336.336,0,0,0-.468.084L24.227,14.749a.334.334,0,0,0-.057.144l-.512,3.516a.336.336,0,0,0,.494.344l3.119-1.7a.33.33,0,0,0,.115-.1L35.143,5.806a.336.336,0,0,0-.084-.468ZM26.88,16.5l-2.459,1.34.4-2.771,7.519-10.8L34.4,5.7Z",
    transform: "translate(-13.491 -2.295)",
    fill: "#ff9f1a",
    stroke: "#ff9f1a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M21.137,14.651a.336.336,0,0,0-.336.336V26.276a1.31,1.31,0,0,1-1.309,1.309H5.287a1.31,1.31,0,0,1-1.309-1.309v-14.2a1.31,1.31,0,0,1,1.309-1.309H13.66a.336.336,0,0,0,0-.673H5.287a1.984,1.984,0,0,0-1.982,1.982v14.2a1.984,1.984,0,0,0,1.982,1.982h14.2a1.984,1.984,0,0,0,1.982-1.982V14.988A.336.336,0,0,0,21.137,14.651Z",
    transform: "translate(0 -6.69)",
    fill: "#ff9f1a",
    stroke: "#ff9f1a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M53.911,1.856l-2.7-1.8a.336.336,0,0,0-.373.56l2.7,1.8a.336.336,0,1,0,.373-.56Z",
    transform: "translate(-31.415)",
    fill: "#ff9f1a",
    stroke: "#ff9f1a",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditt2);
export default __webpack_public_path__ + "static/media/editt 2.c00122aebf3234f39af697f1a04083f2.svg";
export { ForwardRef as ReactComponent };